export default {
    moneyRequests(state) {
        return state.list;
    },
    request(state) {
        return state.request;
    }
}